import { render, staticRenderFns } from "./a-propos.vue?vue&type=template&id=3fa8d380&scoped=true&"
import script from "./a-propos.vue?vue&type=script&lang=js&"
export * from "./a-propos.vue?vue&type=script&lang=js&"
import style0 from "./a-propos.vue?vue&type=style&index=0&id=3fa8d380&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa8d380",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {StoryblokImage: require('/opt/build/repo/components/StoryblokImage.vue').default,ILogoWordFlat: require('/opt/build/repo/components/svg/LogoWordFlat.vue').default,ILikeInsta: require('/opt/build/repo/components/svg/LikeInsta.vue').default,IEye: require('/opt/build/repo/components/svg/Eye.vue').default,IKey: require('/opt/build/repo/components/svg/Key.vue').default,IEco: require('/opt/build/repo/components/svg/Eco.vue').default})
